export enum DiscountSetup {
    DisableDiscount = 0,
    EnableDiscountApprove = 1,
    DiscountPrivilege = 2
}